import SocialShareFooter from './SocialShareFooter';

export default SocialShareFooter;
